export default __webpack_public_path__ + "static/media/face_3_46.ebb90b0a.png";